import { PALETTE, FONT_DISPLAY, FONT_MONO } from "./tokens";

/* Qualitative outcome strip — no fabricated numbers.
   Three concrete outcome categories framed as the result owners
   actually feel in the first month. */
const OUTCOMES = [
  { label: "Hours reclaimed", body: "Owner admin off the calendar. Eva drafts overnight, you approve over coffee." },
  { label: "Owner-approved", body: "Every outbound action waits for your gate until you trust the pattern." },
  { label: "Zero dropped balls", body: "Watchtower flags dropped replies, missed reminders, and stale invoices before customers do." },
];

const SERVICES_OUTCOMES = [
  { label: "15 minutes", body: "That's the first call. An engineer, not a salesperson, telling you whether there's money in this at all." },
  { label: "1 week", body: "Typical time from plan to your first workflow running live. Then we do the next one." },
  { label: "1 engineer", body: "Not a pod, not a project manager. The person who maps your business is the person who builds it." },
];

export const OutcomeStrip = ({ variant = "cobrain" }: { variant?: "cobrain" | "services" }) => {
  const items = variant === "services" ? SERVICES_OUTCOMES : OUTCOMES;
  const tag = variant === "services" ? "How we work" : "Beta cohort outcome";
  return (
  <div style={{
    display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
    gap: 0, border: `1px solid ${PALETTE.line}`, borderRadius: 20,
    background: PALETTE.card, overflow: "hidden",
  }}>
    {items.map((o, i) => (
      <div key={o.label} style={{
        padding: "22px 22px",
        borderLeft: i === 0 ? "none" : `1px solid ${PALETTE.line}`,
        display: "flex", flexDirection: "column", gap: 8,
      }}>
        <span style={{
          fontFamily: FONT_DISPLAY, fontStyle: "italic", fontSize: 26,
          color: PALETTE.ink, lineHeight: 1, fontWeight: 400,
        }}>{o.label}</span>
        <span style={{
          fontFamily: FONT_MONO, fontSize: 10, letterSpacing: "0.14em",
          textTransform: "uppercase", color: PALETTE.amber, fontWeight: 700,
        }}>{tag}</span>
        <p style={{ fontSize: 14, color: PALETTE.ink2, lineHeight: 1.55, margin: "4px 0 0" }}>{o.body}</p>
      </div>
    ))}
  </div>
  );
};